export const GeolocationStatus = {
  NOT_SUPPORT: 'not-support',
  SUCCESS: 'success',
  ERROR: 'error'
}

export const DeliveryTarget = {
  CUSTOM: 'custom',
  COORDINATE: 'coordinate'
}

export const MaskTypes = {
  NUMBER: /^[0-9\b]+$/,
  TWO_DECIMAL_NUMBER: /^[0-9]*(\.[0-9]{0,2})?$/
}
